import script from "./ProgressBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressBlock.vue?vue&type=script&setup=true&lang=js"

import "./ProgressBlock.vue?vue&type=style&index=0&id=285f1bc0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285f1bc0"]])

export default __exports__